var $bf5cce1b47d23baf$exports = {};
$bf5cce1b47d23baf$exports = {
    "Clear search": `T\xf8m s\xf8k`
};


export {$bf5cce1b47d23baf$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
